import Vue from 'vue'
import Vuex from 'vuex'
// vuex的持久化
import createPersistedState from 'vuex-persistedstate'
import page from './modules/page'
import amount from './modules/amount'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    cssCode: '#318ff5',
    activityCode:''
  },
  mutations: {
    setCssCode (state, cssCode) {
      state.cssCode = cssCode
    },
    setActivityCode(state, activityCode) {
      state.activityCode = activityCode
    }
  },
  actions: {
  },
  modules: {
    page,
    amount
  },
   plugins: [createPersistedState()]
})
